import React, { Component } from 'react';
import axios from 'axios';
import QrScanner from 'qr-scanner';

import { IoIosSettings } from 'react-icons/io';
import { IoMdArrowRoundForward } from 'react-icons/io';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            delay: 300,
            resolution: 1000,
            result: '',
            qrRead: false,
            qrCodeImage: '',
            qrReader: 1,
            step: 1,
            lead: '',
            note: '',
            message: 'Scan QR Code',
            invalidScanText: '',
            displayErrorBtn: false,
            displaySignInBtn: false,
            availableCameras: [],
            currentCameraId: '',
            cameraFacingMode: 'environment',
            scanStatus: 'Searching for QR code',
        };

        this.handleError = this.handleError.bind(this);
        this.handleScan = this.handleScan.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleManualCameraSwitch = this.handleManualCameraSwitch.bind(this);
        this.handleAsyncUpdate = this.handleAsyncUpdate.bind(this);
        this.handleDecodeError = this.handleDecodeError.bind(this);
        this.admin = this.admin.bind(this);

        this.textareaRef = React.createRef();
        this.videoRef = React.createRef();

        this.qrScanner = null;
        this.wait = null;
        this.isMountedFlag = false;
        this.lastNoQrStatusUpdate = 0;
        this.isStartingScanner = false;
    }

    async componentDidMount() {
        this.isMountedFlag = true;
        document.getElementById('app-window').focus();

        if (this.props.eventActive === 1 && this.state.step === 1) {
            await this.initializeScanner();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        void this.handleAsyncUpdate(prevProps, prevState);
    }

    componentWillUnmount() {
        this.isMountedFlag = false;

        if (this.wait) {
            clearTimeout(this.wait);
        }

        void this.destroyScanner();
    }

    async handleAsyncUpdate(prevProps, prevState) {
        if (this.state.step === 2 && prevState.step !== 2 && this.textareaRef.current) {
            this.textareaRef.current.focus();
        }

        if (prevProps.eventActive !== this.props.eventActive) {
            if (this.props.eventActive === 1 && this.state.step === 1) {
                await this.destroyScanner();
                await this.initializeScanner();
            } else {
                await this.destroyScanner();
            }
        }

        if (prevState.step !== this.state.step) {
            if (prevState.step === 1 && this.state.step !== 1) {
                await this.destroyScanner();
            }

            if (prevState.step !== 1 && this.state.step === 1 && this.props.eventActive === 1) {
                await this.destroyScanner();
                await this.initializeScanner();
            }
        }
    }

    handleInputChange(e) {
        const itemName = e.target.name;
        const itemValue = e.target.value;

        this.setState({ [itemName]: itemValue });
    }

    handleScan(lead) {
        if (!lead) {
            return;
        }

        if (this.validateLead(lead)) {
            this.setState({
                invalidScanText: '',
                step: 2,
                result: lead,
                lead: lead,
                scanStatus: 'QR code detected',
            });
        } else if (this.state.invalidScanText === '') {
            this.setState({
                invalidScanText: 'Invalid Lead',
                message: '',
                scanStatus: 'QR code detected, but value is invalid',
            });

            this.wait = setTimeout(() => {
                if (!this.isMountedFlag) {
                    return;
                }

                this.setState({
                    invalidScanText: '',
                    message: 'Scan QR Code',
                    scanStatus: 'Searching for QR code',
                });
            }, 3000);
        }
    }

    handleDecodeError() {
        const now = Date.now();

        if (
            now - this.lastNoQrStatusUpdate > 1000 &&
            this.isMountedFlag &&
            this.state.step === 1
        ) {
            this.lastNoQrStatusUpdate = now;
            this.setState({
                scanStatus: 'Searching for QR code',
            });
        }
    }

    handleError(err) {
        console.error(err);
    }

    validateLead(lead) {
        return (
            !isNaN(parseFloat(lead)) &&
            isFinite(lead) &&
            Number(lead) > Number(this.props.eventFirstLeadId)
        );
    }

    isIosDevice() {
        const userAgent = window.navigator.userAgent;
        const isAppleMobile = /iPhone|iPad|iPod/i.test(userAgent);
        const isIpadDesktopMode =
            window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

        return isAppleMobile || isIpadDesktopMode;
    }

    canSwitchCamera() {
        return this.isIosDevice() || this.state.availableCameras.length > 1;
    }

    getPreferredCameraId(cameras, facingMode) {
        if (!Array.isArray(cameras) || cameras.length === 0) {
            return '';
        }

        const backRegex = /(back|rear|environment|trás|achter|后|bag)/i;
        const frontRegex = /(front|user|facetime|frente|vorne|前)/i;

        if (facingMode === 'user') {
            const frontCamera = cameras.find((camera) => frontRegex.test(camera.label));
            return frontCamera ? frontCamera.id : cameras[0].id;
        }

        const backCamera = cameras.find((camera) => backRegex.test(camera.label));
        if (backCamera) {
            return backCamera.id;
        }

        if (cameras.length > 1) {
            return cameras[cameras.length - 1].id;
        }

        return cameras[0].id;
    }

    async refreshCameraList() {
        try {
            const cameras = await QrScanner.listCameras(true);

            if (!this.isMountedFlag) {
                return;
            }

            const preferredCameraId = this.getPreferredCameraId(
                cameras,
                this.state.cameraFacingMode
            );

            this.setState((prevState) => ({
                availableCameras: cameras,
                currentCameraId: prevState.currentCameraId || preferredCameraId,
            }));
        } catch (error) {
            console.log(error);
        }
    }

    async initializeScanner() {
        if (this.props.eventActive !== 1 || this.state.step !== 1 || this.isStartingScanner) {
            return;
        }

        const videoElement = this.videoRef.current;
        if (!videoElement) {
            return;
        }

        try {
            this.isStartingScanner = true;

            this.setState({
                scanStatus: 'Scanner starting...',
            });

            const cameras = await QrScanner.listCameras(true);

            if (!this.isMountedFlag) {
                return;
            }

            if (!Array.isArray(cameras) || cameras.length === 0) {
                this.setState({
                    message: 'No camera found',
                    scanStatus: 'No camera found',
                });
                return;
            }

            const preferredCameraId = this.getPreferredCameraId(
                cameras,
                this.state.cameraFacingMode
            );

            this.qrScanner = new QrScanner(
                videoElement,
                (result) => {
                    const value =
                        result && typeof result === 'object' && 'data' in result
                            ? result.data
                            : result;

                    this.handleScan(value);
                },
                {
                    preferredCamera: this.isIosDevice()
                        ? this.state.cameraFacingMode
                        : preferredCameraId,
                    returnDetailedScanResult: true,
                    highlightScanRegion: false,
                    highlightCodeOutline: false,
                    maxScansPerSecond: 10,
                    onDecodeError: this.handleDecodeError,
                }
            );

            await this.qrScanner.start();

            this.setState({
                availableCameras: cameras,
                currentCameraId: preferredCameraId,
                scanStatus: 'Searching for QR code',
            });
        } catch (error) {
            console.log(error);

            if (this.isMountedFlag) {
                this.setState({
                    message: 'Camera could not be started',
                    scanStatus: 'Camera could not be started',
                });
            }
        } finally {
            this.isStartingScanner = false;
        }
    }

    async destroyScanner() {
        if (!this.qrScanner) {
            return;
        }

        try {
            await this.qrScanner.destroy();
        } catch (error) {
            console.log(error);
        } finally {
            this.qrScanner = null;
        }
    }

    async handleManualCameraSwitch() {
        if (!this.qrScanner) {
            return;
        }

        try {
            if (this.isIosDevice()) {
                const nextFacingMode =
                    this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';

                this.setState({
                    cameraFacingMode: nextFacingMode,
                    scanStatus: 'Switching camera...',
                    message: 'Scan QR Code',
                });

                await this.qrScanner.setCamera(nextFacingMode);

                if (!this.isMountedFlag) {
                    return;
                }

                this.setState({
                    scanStatus: 'Searching for QR code',
                });

                return;
            }

            const cameras =
                this.state.availableCameras.length > 0
                    ? this.state.availableCameras
                    : await QrScanner.listCameras(true);

            if (!Array.isArray(cameras) || cameras.length < 2) {
                return;
            }

            const currentIndex = cameras.findIndex(
                (camera) => camera.id === this.state.currentCameraId
            );

            const safeIndex = currentIndex >= 0 ? currentIndex : 0;
            const nextIndex = (safeIndex + 1) % cameras.length;
            const nextCamera = cameras[nextIndex];

            this.setState({
                currentCameraId: nextCamera.id,
                scanStatus: 'Switching camera...',
                message: 'Scan QR Code',
            });

            await this.qrScanner.setCamera(nextCamera.id);

            if (!this.isMountedFlag) {
                return;
            }

            this.setState({
                availableCameras: cameras,
                scanStatus: 'Searching for QR code',
            });
        } catch (error) {
            console.log(error);

            if (this.isMountedFlag) {
                this.setState({
                    message: 'Camera switch failed',
                    scanStatus: 'Camera switch failed',
                });
            }
        }
    }

    postLead() {
        this.setState({ displayErrorBtn: false });

        const data = {
            lead: this.state.lead,
            note: this.state.note,
            token: this.props.token,
            event_id: this.props.eventId,
        };

        this.setState({
            message: 'Sending Lead',
            step: 4,
        });

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=postLead',
            data: JSON.stringify(data),
        }).then((responseObject) => {
            if (responseObject.data.valid_token === true) {
                this.props.connectionError(false);
                this.setState({ message: 'Lead has been registered' });

                this.wait = setTimeout(() => {
                    if (!this.isMountedFlag) {
                        return;
                    }

                    this.setState({
                        message: '',
                        note: '',
                        step: 1,
                        lead: '',
                        scanStatus: 'Searching for QR code',
                    });
                }, 2000);
            } else {
                this.setState({
                    message: responseObject.data.result,
                    displaySignInBtn: true,
                });
            }
        }).catch((error) => {
            console.log(error);

            this.props.connectionError(true);
            this.setState({
                message: 'ERROR: Lead has NOT been registered. This may be due to a lack of internet connection!',
                displayErrorBtn: true,
            });
        });
    }

    dismissLead() {
        this.setState({
            message: 'Lead has not been added',
            step: 0,
        });

        this.wait = setTimeout(() => {
            if (!this.isMountedFlag) {
                return;
            }

            this.setState({
                note: '',
                step: 1,
                message: '',
                lead: '',
                scanStatus: 'Searching for QR code',
            });
        }, 2000);
    }

    admin() {
        this.props.changeScreen('admin');
    }

    render() {
        const { eventActive, companyId, companyName, initials, colors, logoTop, logoBottom } = this.props;

        const frontStyle = {
            color: colors.color_1,
            textShadow: '0px 4px 3px #00000030',
            whiteSpace: 'pre-wrap',
        };

        const userStyle = {
            color: colors.color_1 + 'BB',
        };

        const btnStyle = {
            color: colors.color_1,
            backgroundColor: colors.color_2,
            cursor: 'pointer',
        };

        const invalidScanStyle = {
            color: colors.color_3,
            fontWeight: 'bold',
        };

        return (
            <div className="container-fluid d-flex align-items-center vh-100">
                <div className="row d-flex justify-content-center vh-100 vw-100">
                    <div className="content-wrapper page-home col-12 col col-sm-8 col-lg-6">

                        {logoTop !== '' &&
                            <div className="section-top-wrapper">
                                <img id="logo" src={logoTop} alt="Logo" />
                            </div>
                        }

                        <div className="content pt-2">
                            {this.state.message !== '' &&
                                <div
                                    id="message"
                                    className="mt-3 mb-3 text-center"
                                    style={frontStyle}
                                    dangerouslySetInnerHTML={{ __html: this.state.message }}
                                />
                            }

                            {this.state.invalidScanText !== '' &&
                                <div
                                    id="message"
                                    className="mt-3 mb-3 text-center"
                                    style={invalidScanStyle}
                                    dangerouslySetInnerHTML={{ __html: this.state.invalidScanText }}
                                />
                            }

                            {this.state.displayErrorBtn &&
                                <div className="text-center">
                                    <button className="btn-medium m-2" type="button" style={btnStyle} onClick={() => this.postLead()}>
                                        SEND AGAIN <IoMdArrowRoundForward />
                                    </button>
                                </div>
                            }

                            {this.state.displaySignInBtn &&
                                <div className="text-center">
                                    <button className="btn-medium m-2" type="button" style={btnStyle} onClick={() => this.props.changeScreen('setup', '')}>
                                        SIGN IN <IoMdArrowRoundForward />
                                    </button>
                                </div>
                            }

                            {eventActive === 1 && this.state.qrReader === 1 && this.state.step === 1 &&
                                <div id="qr-wrapper" className="col-12 text-center">
                                    <div id="qr-container" style={{ width: '100%' }}>
                                        <video
                                            ref={this.videoRef}
                                            style={{
                                                width: '100%',
                                                minHeight: '320px',
                                                borderRadius: '16px',
                                                objectFit: 'cover',
                                                display: 'block',
                                            }}
                                            muted
                                            playsInline
                                        />

                                        <div style={{ marginTop: '10px' }}>
                                            <p style={frontStyle}>{this.state.scanStatus}</p>
                                        </div>

                                        {this.canSwitchCamera() &&
                                            <div className="text-center mt-2">
                                                <button
                                                    className="btn-medium m-2"
                                                    type="button"
                                                    style={btnStyle}
                                                    onClick={this.handleManualCameraSwitch}
                                                >
                                                    SWITCH CAMERA
                                                </button>
                                            </div>
                                        }

                                        <p style={frontStyle}>{this.state.lead}</p>
                                    </div>
                                </div>
                            }

                            {eventActive === 0 && this.state.qrReader === 1 && this.state.step === 1 &&
                                <div className="text-center">
                                    <div id="inactive">Lead Scan has been disabled</div>
                                </div>
                            }

                            {this.state.step === 2 &&
                                <div>
                                    <div className="mb-2" style={frontStyle}>Lead: {this.state.lead}</div>
                                    <div>
                                        <textarea
                                            className={"form-control pl-3"}
                                            rows="5"
                                            id="note"
                                            name="note"
                                            placeholder="note"
                                            defaultValue=""
                                            onChange={this.handleInputChange}
                                            ref={this.textareaRef}
                                        />
                                    </div>

                                    <div className="text-center mt-3">
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={() => this.dismissLead()}>
                                            DISMISS <IoMdArrowRoundForward />
                                        </button>
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={() => this.postLead()}>
                                            SAVE <IoMdArrowRoundForward />
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="section-bottom-wrapper mt-2">
                            {this.state.step === 1 &&
                                <div className="form-group text-center" style={userStyle}>
                                    <div id="user">
                                        <div>SIGNED IN AS</div>
                                        <div>Company: {companyName}</div>

                                        {initials !== '' &&
                                            <div>Initials: {initials}</div>
                                        }
                                    </div>

                                    {parseFloat(companyId) === 1 &&
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.admin}>
                                            Admin <IoIosSettings />
                                        </button>
                                    }

                                    {parseFloat(companyId) !== 1 &&
                                        <button className="btn-medium m-2" type="button" style={btnStyle} onClick={this.admin}>
                                            Menu <IoIosSettings />
                                        </button>
                                    }
                                </div>
                            }

                            {logoBottom !== '' &&
                                <div className="section-bottom-wrapper">
                                    <div className="text-center mt-5">
                                        <img id="logo-bottom" src={logoBottom} alt="Logo" />
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default Home;